<template>
  <v-container fluid>
    <!-- Card Headline -->
    <v-row>
      <v-col class="text-center d-none d-md-block">
        <v-card
        tile
        elevation="16"
        >
          <v-card-title>
            <h1>Walter Raab ist <br> Unternehmenssanierer</h1>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <!-- 2 Col Layout -->
    <v-row>
      <v-col cols="12" md="4">
        <v-img
          alt="verkauf unternehmen"
          src="@/assets/images/walterraab_unternehmenscoach.jpg"
        />
        <v-card
        tile
        elevation="16"
        class="d-block d-md-none mobile-card"
        >
          <v-card-title>
            <h1>Walter Raab ist <br> Unternehmenssanierer.</h1>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col>
        <p>
          Ursprünglich komme ich aus dem Handwerk. Als Verkaufsleiter in einem großen Handwerksunternehmen und Direktor Marketing in einem großen Handelsunternehmen sammelte ich umfangreiche Praxiserfahrung. 2003 gründete ich die Firma Raab Coaching in Deutschland und 2007 eine Niederlassung in Österreich.
        </p>
        <p>
          Als Coach betreuen ich und mein Team seitdem hauptsächlich Handwerker und mittelständische Unternehmer in Wachstums- und Sanierungssituationen sowie beim Kauf und Verkauf von Unternehmen.
        </p>

        <h3>Qualifikationen</h3>
        <ul>
          <li>Betriebswirt (HWK)</li>
          <li>Unternehmercoach</li>
          <li>Außenwirtschaftsberater</li>
          <li>Zulassung als Unternehmensberater in Österreich gemäß § 94 Z. 74 GewO</li>
        </ul>
        <hr>
        <p>Das sind wir:</p>
        <!-- Normal Carousel -->
        <v-carousel
          :hide-delimiters="true"
          height="120"
          class="d-none d-md-block"
        >
          <v-carousel-item
            v-for="item in items"
            :key="item.text"
            >
            <v-row class="fill-height"
              align="center"
              justify="center"
            >
              <div v-html="item.text" class="zeitung-text text-center"  />
            </v-row>
          </v-carousel-item>
        </v-carousel>

        <!-- small screen carousel -->
        <v-carousel
          :hide-delimiters="true"
          height="200"
          class="d-block d-md-none"
        >
          <v-carousel-item
            v-for="item in items"
            :key="item.text"
            >
            <v-row class="fill-height"
              align="center"
              justify="center"
            >
              <div v-html="item.text" class="zeitung-text"  />
            </v-row>
          </v-carousel-item>
        </v-carousel>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        text: 'Magdalena Derse <br> Assistenz der GF'
      },
      {
        text: 'Melanie Hofbauer <br> Projektassistenz'
      },
      {
        text: 'Ute Raab <br> Organisation'
      },
      {
        text: 'Detlef Gagel <br> Logistik'
      }
    ]
  })
}
</script>

<style scoped lang="scss">
  // Container BG and Sizing
  .container {
    background-color: $light-sky-blue;
    margin-top: -5.6rem;
    padding-bottom: 2.5rem;
    position: relative;
    bottom: 180px;
    margin-bottom: -180px;
  }

  .zeitung-text {
    font-size: 1.33rem;
    font-style: italic;
    line-height: 1.25;
    letter-spacing: .16;
    color: $dark-grey-blue;
    max-width: 500px;
    text-align: center;
  }

  p,
  li {
    color: $dark-grey-blue;
  }

  h1 {
    color: $sapphire;
    margin: .84em .97em .8em 1.11em;
  }

  h3 {
    font-weight: 900;
    line-height: 1.33;
    letter-spacing: .18px;
    color: $dark-grey-blue;
    margin-top: 1.94em;
    margin-bottom: 1.5em;
  }

  .v-card {
    display: inline-block;
    z-index: 10;
    margin-left: 3em;
    position: relative;
    bottom: 2.6em;
  }

  .v-carousel {
    background-color: rgba(255, 255, 255, .4);
    border-top: solid 2px rgba(38, 47, 92, .19);
    border-bottom: solid 2px rgba(38, 47, 92, .19);
  }

  .mobile-card {
    margin-left: 0;

    h1 {
      font-size: 1.5rem;
    }
  }

  @media screen and (max-width: 1263px) {
    .container {
      bottom: 0px;
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 959px) {
    .container {
      margin-top: -2rem;
    }
  }

  @media screen and (max-width: 660px) {
    .zeitung-text {
      max-width: 200px;
    }

    h1 {
      margin: 0;
    }
  }

  @media screen and (max-width: 410px) {
    .mobile-card {
      h1 {
        font-size: 1rem;
      }
    }
  }
</style>
